"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomerIdentify = void 0;
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var useCustomerIdentify = function () {
    var data = (0, swr_hooks_1.useUser)().data;
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (data && (window === null || window === void 0 ? void 0 : window['_cio'])) {
            window['_cio'].identify({
                id: (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a.getOne) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.contacts) === null || _d === void 0 ? void 0 : _d.email,
                // email: data?.profile?.getOne?.profile?.contacts?.email,
                first_name: (_h = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.profile) === null || _e === void 0 ? void 0 : _e.getOne) === null || _f === void 0 ? void 0 : _f.profile) === null || _g === void 0 ? void 0 : _g.personal) === null || _h === void 0 ? void 0 : _h.firstName,
                last_name: (_m = (_l = (_k = (_j = data === null || data === void 0 ? void 0 : data.profile) === null || _j === void 0 ? void 0 : _j.getOne) === null || _k === void 0 ? void 0 : _k.profile) === null || _l === void 0 ? void 0 : _l.personal) === null || _m === void 0 ? void 0 : _m.lastName,
            });
        }
    }, [data]);
};
exports.useCustomerIdentify = useCustomerIdentify;
